import script from "./BlockListExport.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockListExport.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__